import { render, staticRenderFns } from "./Modules.v1.Detail.vue?vue&type=template&id=26ea6ed4&"
import script from "./Modules.v1.Detail.vue?vue&type=script&lang=js&"
export * from "./Modules.v1.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports